import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=57cafee7"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports